module.exports = __webpack_public_path__ + "img/p22.a010fe56.png";